import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { GreyContainer, LargeWrapper, PopoverHeader } from './SharedStyleComponents';
import { useRandomContentAssistanceTip } from './useRandomContentAssistanceTipsAndQuips';
import { AISkeleton } from 'ai-components-ui-library/components/loading/AISkeleton';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { keyframes } from 'styled-components';
import { View } from 'foundations-components/transitional/components/View';
import { BulbIcon } from 'foundations-assets/icons/components/BulbIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const aiSkeletonKeyframesAnimation = keyframes(["100%{transform:translateX(5%);}"]);
const AISkeletonWrapper = styled(AISkeleton).attrs({
  'data-test-id': 'ai-skeleton-wrapper'
}).withConfig({
  displayName: "ContentAssistantLoadingScreen__AISkeletonWrapper"
})(["&::after{animation:", " 3s ease-out infinite;}"], aiSkeletonKeyframesAnimation);
export default function ContentAssistantLoadingScreen({
  body,
  label,
  onCancel,
  tips
}) {
  const randomTipKey = useRandomContentAssistanceTip(tips);
  return /*#__PURE__*/_jsxs(LargeWrapper, {
    "data-loading": true,
    children: [/*#__PURE__*/_jsx(PopoverHeader, {
      label: label,
      onCancel: onCancel,
      body: body
    }), /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      padding: "200",
      children: [/*#__PURE__*/_jsx(AISkeletonWrapper, {
        shape: "rect",
        height: 20,
        className: "m-y-1"
      }), /*#__PURE__*/_jsx(AISkeletonWrapper, {
        shape: "rect",
        height: 20,
        className: "m-y-1"
      }), /*#__PURE__*/_jsx(AISkeletonWrapper, {
        shape: "rect",
        width: 50,
        height: 20,
        className: "m-y-1"
      })]
    }), /*#__PURE__*/_jsxs(GreyContainer, {
      justifyContent: "start",
      marginBlockStart: "auto",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineEnd: "100",
        children: /*#__PURE__*/_jsx(BulbIcon, {})
      }), /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "tips.tip"
        }), ":", ' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: randomTipKey
        })]
      })]
    })]
  });
}